import React from 'react';
import clsx from 'clsx';
import useStyles from './styles';
import ButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase';

const Hamburger = (props: HamburgerProps) => {
  const { isOpen, className, ...other } = props;
  const { classes } = useStyles();

  /**
   * Renders a bar of the three bar hamburger menu along with its animation class
   */
  const renderBar = (animatedClass: string) => {
    return <div className={clsx(classes.menuBarBase, isOpen && animatedClass)} />;
  };

  return (
    <ButtonBase aria-label="menu" disableRipple className={className} {...other}>
      <div className={clsx(classes.root, classes.button)} suppressHydrationWarning>
        {renderBar(classes.animatedTopBar)}
        {renderBar(classes.animatedMidBar)}
        {renderBar(classes.animatedBottomBar)}
      </div>
    </ButtonBase>
  );
};

export interface HamburgerProps extends ButtonBaseProps {
  isOpen: boolean;
}

export default Hamburger;
